import { Component, OnInit, Input } from '@angular/core';
import { EntityDirectoryService } from '../../entity-directory.service';
import { SessionService } from '../../../../services';

@Component({
  selector: 'entity-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class EntityDashboardComponent implements OnInit {
  // Is passed to the dashboard component to trigger ngOnChanges.
  @Input() active;
  currencyIsoCode: string;

  constructor(
    public service: EntityDirectoryService,
    public sessionService: SessionService
  ) { }

  ngOnInit() {
    this.currencyIsoCode = this.sessionService.getContainerUpeCurrency().isoCode;
  }
}
